import { useMemo } from 'react';

import { invite as inviteService } from '@atlassian/expansion-services/services';

import { useService } from '@confluence/expansion-services';

export const useInvite = () => {
	// Passing the deps arg, even empty, enables a type safety check against declared deps
	const deps = useMemo(() => ({}), []);
	return useService(inviteService, deps);
};
